import React, { useRef } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  AttachFile as AttachFileIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { formatFileSize } from '../../utils/formatters';

const ProofUploadField = ({ file, onFileChange, label = 'Proof of Document' }) => {
  const inputRef = useRef(null);

  const handleClick = () => inputRef.current?.click();
  const handleClear = (e) => {
    e.stopPropagation();
    onFileChange(null);
    if (inputRef.current) inputRef.current.value = '';
  };
  const handleChange = (e) => {
    const f = e.target.files?.[0] || null;
    onFileChange(f);
  };

  return (
    <Box>
      <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,image/*"
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <Button
        variant="outlined"
        fullWidth
        onClick={handleClick}
        startIcon={file ? <AttachFileIcon /> : <CloudUploadIcon />}
        sx={{
          justifyContent: 'flex-start',
          borderStyle: 'dashed',
          textTransform: 'none',
          py: 1.5,
        }}
      >
        {file ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, overflow: 'hidden' }}>
            <Box sx={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {file.name} <Typography component="span" variant="caption" color="textSecondary">({formatFileSize(file.size)})</Typography>
            </Box>
            <IconButton size="small" onClick={handleClear} component="span">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary">Click to attach a document</Typography>
        )}
      </Button>
    </Box>
  );
};

export default ProofUploadField;
